

































































import Vue from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import Button from '@/components/form/Button.vue';
import FieldSelect from '../form/FieldSelect.vue';
import FieldCheckbox from '../form/FieldCheckbox.vue';

export default Vue.extend({
  name: 'RegisterPublisher',
  components: {
    FieldInput,
    Button,
    FieldSelect,
    FieldCheckbox,
  },
  props: {
    formElements: {
      type: Object,
    },
    acceptButtonDisabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    goBack() {
      this.$emit('goBack');
    },
  },

  data() {
    return {
      // (до 50 000, от 50 000 до 100 000, от 100 000 до 500 000, от 500 000 до 1 000 000, от 1 000 000)
      visitorsList: [
        {
          label: '< 50 000',
          value: 0,
        },
        {
          label: '50 000 - 100 000',
          value: 1,
        },
        {
          label: '100 000 - 500 000',
          value: 2,
        },
        {
          label: '500 000 - 1 000 000',
          value: 3,
        },
        {
          label: '> 1 000 000',
          value: 4,
        },
      ],
    };
  },
});
